import React from "react";
import {Field, reduxForm} from "redux-form";
import {Textarea} from "../../../../Utilits/Fields";
import "./profilePostsField.sass"

const ProfileField = (props) => {
    return(
        <form onSubmit={props.handleSubmit} className='profile__post-form'>
            <div className="profile__form form"><Field name='postMessage' component={Textarea} placeholder='Введите ваше сообщение'/></div>
            <div className='profile__submit-button submit-button'><button>Опубликовать</button></div>
            <div className='profile__sender-post'><img src={props.myPhotos} alt=""/></div>{/*заглушка фото*/}
        </form>
    )
};

export default reduxForm({form: 'post'})(ProfileField)